import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-95b7cc3a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "condition-row__condition--name" };
const _hoisted_2 = {
    key: 0,
    class: "condition-row__condition--operator"
};
const _hoisted_3 = { class: "condition-row__condition--labelField" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
    key: 2,
    class: "condition-row__condition--value"
};
const _hoisted_6 = { class: "condition-row__condition" };
const _hoisted_7 = { class: "condition-row__condition--name" };
const _hoisted_8 = { class: "condition-row__condition--operator" };
const _hoisted_9 = { class: "condition-row__condition--value" };
const _hoisted_10 = ["title", "onClick"];
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    "aria-hidden": "true",
    class: "icon icon-close"
}, null, -1));
const _hoisted_12 = [
    _hoisted_11
];
import { computed, inject } from 'vue';
import { useStore } from 'vuex';
import { useAudienceManager } from '@/features/AudienceManager/composables/useAudienceManager';
import { formatCurrency } from '@/utilities/formatters';
import { formatLabels } from '@/features/AudienceManager/utils/format';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceConditionRow',
    props: {
        rowId: {},
        condition: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const isInclude = inject('isInclude');
        const groupIndex = inject('groupIndex');
        const groupType = inject('groupType');
        const { isViewMode, allCriteriaOptions } = useAudienceManager(isInclude, groupIndex);
        const hasQueryCondition = computed(() => Object.keys(props.condition).length > 0);
        const criteriaDetails = computed(() => getCriteriaDetailsByKey(props.condition?.column));
        const hasFilterKeys = computed(() => Boolean(props.condition.f_operator));
        const formattedValue = computed(() => {
            if (!props.condition || !criteriaDetails.value)
                return '';
            if (isBetweenOperator.value)
                return formattedRange.value;
            if (hasPredefinedOptions.value)
                return formattedPredefinedOptions.value;
            if (props.condition.value.length)
                return formattedCustomValue.value;
            return props.condition.labelField;
        });
        const isBetweenOperator = computed(() => {
            const isBetween = props.condition.operator === 'between';
            const hasTwoValidValues = Array.isArray(props.condition.value) && props.condition.value.length === 2;
            return isBetween && hasTwoValidValues;
        });
        const formattedRange = computed(() => {
            const [start, end] = props.condition.value;
            return isBetweenOperator.value ? `${start} - ${end}` : '';
        });
        const formattedPredefinedOptions = computed(() => {
            const isAutocomplete = criteriaDetails.value?.autocomplete;
            const hasAutocompleteSelections = props.condition.referenceObjects && Object.keys(props.condition.referenceObjects).length > 0;
            let options = [];
            if (isAutocomplete && hasAutocompleteSelections) {
                options = [...Object.values(props.condition.referenceObjects)];
            }
            else {
                const staticOptions = props.condition.value.map(key => criteriaDetails.value?.options[key] || key);
                options = [...staticOptions];
            }
            if (options.length === 0)
                return '';
            return formatLabels(options);
        });
        const formattedCustomValue = computed(() => {
            const values = props.condition.value;
            const format = criteriaDetails.value?.format || '';
            const isSingleValue = values.length === 1;
            return isSingleValue ? formatValue(values[0], format) : values.map(val => formatValue(val, format)).join(', ');
        });
        const hasPredefinedOptions = computed(() => {
            const hasStaticOptions = !!criteriaDetails.value?.options && Array.isArray(props.condition.value) && props.condition.value.length > 0;
            const hasAutocompleteSelections = criteriaDetails.value?.autocomplete &&
                props.condition.referenceObjects &&
                Object.keys(props.condition.referenceObjects).length > 0;
            return hasStaticOptions || hasAutocompleteSelections;
        });
        const shouldShowTooltip = computed(() => tooltipContent.value !== '' && (isViewMode.value || hasPredefinedOptions.value));
        const tooltipContent = computed(() => {
            const refs = Object.values(props.condition.referenceObjects || {});
            const values = props.condition.value || [];
            const MAX_VISIBLE_ITEMS = 2;
            const hasManyRefs = refs.length > MAX_VISIBLE_ITEMS;
            const hasManyValues = values.length > MAX_VISIBLE_ITEMS;
            const itemsToShow = hasManyRefs ? refs : hasManyValues ? values : [];
            if (!itemsToShow.length)
                return '';
            const content = formatReferenceValues(itemsToShow.map(String));
            return `<div class="tooltip-multiple-info">${content}</div>`;
        });
        const formatReferenceValues = (values) => {
            return shouldBreakLines(values) ? values.join('<br/>') : values.join(', ');
        };
        const shouldBreakLines = (values) => {
            const totalCharactersInAllValues = values.reduce((sum, value) => sum + value.length, 0);
            const totalValuesCount = values.length;
            const characterLimitForLineBreak = 20;
            const averageTextLength = totalCharactersInAllValues / totalValuesCount;
            return averageTextLength > characterLimitForLineBreak;
        };
        const formatValue = (value, format) => {
            return format === 'currency' ? formatCurrency(value) : String(value);
        };
        const getCriteriaDetailsByKey = (criteriaKey) => {
            if (!criteriaKey)
                return undefined;
            const criteriaOptions = allCriteriaOptions.value.flatMap(group => group.columns);
            const selectedCriteria = criteriaOptions.find(criteria => criteria.key === criteriaKey);
            return selectedCriteria;
        };
        const editCondition = () => {
            if (isViewMode.value)
                return;
            store.dispatch('audienceManager/setConditionEditMode', true);
            store.dispatch('audienceManager/updateSelectedCriteria', {
                criteriaKey: props.condition.column,
                groupType,
                groupIndex,
            });
            store.dispatch('audienceManager/setEditingCondition', {
                groupType,
                groupIndex,
                rowId: props.rowId,
                draftCondition: props.condition,
            });
            store.dispatch('audienceManager/toggleConditionForm', { isVisible: true, groupIndex });
        };
        const removeCondition = () => {
            store.dispatch('audienceManager/removeCondition', {
                groupType,
                groupIndex,
                rowId: props.rowId,
            });
        };
        const popoverStyle = computed(() => ({
            minWidth: '280px',
            maxWidth: '400px',
            width: 'auto',
        }));
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            return (hasQueryCondition.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["condition-row", { editable: !_unref(isViewMode) }])
                }, [
                    _createElementVNode("a", {
                        class: "condition-row__condition",
                        onClick: editCondition
                    }, [
                        _createElementVNode("span", _hoisted_1, _toDisplayString(criteriaDetails.value?.name), 1),
                        (!hasFilterKeys.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t(`audiences.operators.${props.condition.operator}`)), 1))
                            : _createCommentVNode("", true),
                        (shouldShowTooltip.value)
                            ? (_openBlock(), _createBlock(_component_el_popover, {
                                key: 1,
                                trigger: "hover",
                                placement: "top",
                                "popper-style": popoverStyle.value
                            }, {
                                reference: _withCtx(() => [
                                    _createElementVNode("strong", _hoisted_3, _toDisplayString(formattedValue.value), 1)
                                ]),
                                default: _withCtx(() => [
                                    _createElementVNode("p", {
                                        innerHTML: tooltipContent.value,
                                        class: "condition-row__condition--tooltip customScrollBar"
                                    }, null, 8, _hoisted_4)
                                ]),
                                _: 1
                            }, 8, ["popper-style"]))
                            : (formattedValue.value)
                                ? (_openBlock(), _createElementBlock("strong", _hoisted_5, _toDisplayString(formattedValue.value), 1))
                                : _createCommentVNode("", true),
                        (hasFilterKeys.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createElementVNode("span", _hoisted_6, [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(criteriaDetails.value?.filter.name), 1),
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(`audiences.operators.${props.condition.f_operator}`)), 1)
                                ]),
                                _createElementVNode("strong", _hoisted_9, _toDisplayString(props.condition.f_value[0]), 1),
                                (props.condition.f_value.length === 2)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('and')), 1),
                                        _createElementVNode("strong", null, _toDisplayString(props.condition.f_value[1]), 1)
                                    ], 64))
                                    : _createCommentVNode("", true)
                            ], 64))
                            : _createCommentVNode("", true)
                    ]),
                    (!_unref(isViewMode))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "condition-row__btn-remove-condition",
                            title: _ctx.$t('remove'),
                            onClick: _withModifiers(removeCondition, ["prevent"])
                        }, _hoisted_12, 8, _hoisted_10))
                        : _createCommentVNode("", true)
                ], 2))
                : _createCommentVNode("", true);
        };
    }
});
